document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 480 && window.location.href.includes("/products/")) {
    const addToCartButton = document.querySelector("[data-add-to-cart]");
    const productDesc = document.querySelector(".desc-txt.product_desc");
    const klarnaPlacement = document.querySelector("klarna-placement");
    const qtyWrapper = document.querySelector(
      ".itemscope-details .qty-wrapper"
    );

    if (addToCartButton && productDesc) {
      addToCartButton.insertAdjacentElement("afterend", productDesc);
    }

    if (qtyWrapper && klarnaPlacement) {
      qtyWrapper.insertAdjacentElement("afterend", klarnaPlacement);
    }
  }

  function adjustFacetFiltersPosition() {
    if (
      document.body.classList.contains("template-collection") &&
      document.querySelector(".title_and_filters") &&
      document.querySelector("#FacetFiltersFormMobile") &&
      document.querySelector(".options-group") &&
      document.querySelector(".mobile-facets__close")
    ) {
      var collectionTitleHeight =
        document.querySelector(".title_and_filters").clientHeight;

      if (collectionTitleHeight) {
        document.querySelector(
          "#FacetFiltersFormMobile"
        ).style.top = `${collectionTitleHeight}px`;
        document.querySelector(
          ".options-group"
        ).style.top = `${collectionTitleHeight}px`;
        document.querySelector(".mobile-facets__close").style.top = `${
          collectionTitleHeight + 5
        }px`;
      }
    }
  }

  window.addEventListener("load", adjustFacetFiltersPosition);
  window.addEventListener("resize", debounce(adjustFacetFiltersPosition, 100));

  let accJoinTeam = document.querySelectorAll(".join-team__item--button");
  if (accJoinTeam.length > 0) {
    accJoinTeam.forEach((item) => {
      item.addEventListener("click", function () {
        let openElement = item.nextElementSibling;
        if (
          openElement &&
          openElement.classList.contains("join-team__item--information")
        ) {
          $(openElement).slideToggle();
        }
      });
    });
  }

  ///cookies////

  /*const btnCookie = document.getElementById('cookie_btn')
  const cookiePoster = document.getElementById('cookie_poster')

  if (localStorage.getItem('cookie-accepted')) {

    cookiePoster.classList.remove('active-cookie')
    console.log("hola");

  }

  btnCookie.addEventListener('click', ()=>{

    console.log("chau");
    cookiePoster.classList.remove('active-cookie')
    localStorage.setItem('cookie-accepted', true)

  })*/

  window.getCookie = (name) => {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  let popupCookies = document.querySelector("#cookie_poster");

  if (popupCookies) {
    // console.log("hola");
    let existCookies = window.getCookie("popUpcookie");

    if (existCookies === null) {
      setTimeout(function () {
        popupCookies.classList.add("active-cookie");
        // console.log("hola1");
      }, 2000);

      let closePupup = document.querySelector("#cookie_btn");
      closePupup.addEventListener("click", () => {
        let now = new Date();
        let time = now.getFullYear();
        let expiretime = time + 1;

        now.setFullYear(expiretime);
        document.cookie = "popUpcookie=ok;expires=" + now + ";path=/";
        // console.log("hola2");
        popupCookies.classList.remove("active-cookie");
      });
    }
  }

  // Mobile homepage reorder
  /*if ( window.innerWidth <= 640 ) {
    let why = document.getElementById('block--1573147184045');
    let style = document.getElementById('block--1573147238792');
    let stores = document.getElementById('block--1573147262320');
    let material = document.getElementById('block--1573147309174');

    const mobileDiv = document.getElementById('mobile__home-container');

    mobileDiv.appendChild(style);
    mobileDiv.appendChild(material);
    mobileDiv.appendChild(stores);
    mobileDiv.appendChild(why);
  }*/

  // Mobile homepage reorder
  if (location.pathname == "/") {
    const why = document.getElementById("block--1573147184045");
    const style = document.getElementById("block--1573147238792");
    const stores = document.getElementById("block--1573147262320");
    const material = document.getElementById("block--1573147309174");

    const mobileDiv = document.getElementById("mobile__home-container");

    const homeVideo = document.querySelector("#shopify-section-homepage-video");
    const homeTop = document.querySelector("#shopify-section-homepage-top");
    const homeBottom = document.querySelector(
      "#shopify-section-homepage-bottom"
    );

    // why.dispatchEvent(new Event('mouseover'))
    // style.dispatchEvent(new Event('mouseover'))
    // stores.dispatchEvent(new Event('mouseover'))
    // material.dispatchEvent(new Event('mouseover'))

    if (window.innerWidth <= 640) {
      if (mobileDiv) {
        mobileDiv.appendChild(style);
        mobileDiv.appendChild(material);
        mobileDiv.appendChild(stores);
        mobileDiv.appendChild(why);
      }
    }

    window.addEventListener("resize", (evt) => {
      if (window.innerWidth <= 640) {
        if (mobileDiv?.childElementCount == 0) {
          mobileDiv.appendChild(style);
          mobileDiv.appendChild(material);
          mobileDiv.appendChild(stores);
          mobileDiv.appendChild(why);
        }
        return;
      }

      if (homeVideo.children.length == 0) {
        homeVideo.append(why);
        homeTop.append(style);
        homeTop.append(stores);
        homeBottom.append(material);
      }
    });
  }

  if (window.innerWidth <= 640) {
    const creditPromotionElement = document.querySelector(
      '[data-key="credit-promotion-auto-size"]'
    );
    const productDesc = document.querySelector(".desc-txt.product_desc");

    if (creditPromotionElement && productDesc) {
      setTimeout(() => {
        productDesc.insertAdjacentElement(
          "beforebegin",
          creditPromotionElement
        );
      }, 500);
    }
  }

  // PB+J custom collapse start and end sections
  const collapsibleElements = document.querySelectorAll(".collapse-start");
  if (collapsibleElements.length) {
    collapsibleElements.forEach((element) => {
      if (hasCollapseEndSibling(element)) {
        applyInitialHeightForTransition(element);
        element.addEventListener("click", () => {
          closeOtherCollapses(element);
          toggleCollapse(element);
        });
      }
    });

    window.addEventListener("resize", () => {
      collapsibleElements.forEach((element) => {
        if (hasCollapseEndSibling(element)) {
          toggleResizeCollapse(element);
        }
      });
    });

    const startCollapsedElements =
      document.querySelectorAll(".start-collapsed");
    startCollapsedElements.forEach((element) => {
      if (hasCollapseEndSibling(element.parentElement)) {
        toggleCollapse(element.parentElement);
      }
    });

    function hasCollapseEndSibling(element) {
      let sibling = element.nextElementSibling;

      while (sibling !== null) {
        if (sibling.classList.contains("collapse-end")) {
          return true;
        }
        sibling = sibling.nextElementSibling;
      }
      console.log("Collapse End Section Missing in Page!");
      return false;
    }

    function toggleCollapse(element) {
      let sibling = element.nextElementSibling;
      while (sibling && !sibling.classList.contains("collapse-end")) {
        if (sibling.style.height === "" || sibling.style.height === "0px") {
          sibling.style.height = sibling.scrollHeight + "px";
        } else {
          sibling.style.height = "0px";
        }
        sibling = sibling.nextElementSibling;
      }
    }

    function toggleResizeCollapse(element) {
      let sibling = element.nextElementSibling;
      while (sibling && !sibling.classList.contains("collapse-end")) {
        if (sibling.style.height !== "" && sibling.style.height !== "0px") {
          sibling.style.height = "auto";
          sibling.style.height = sibling.scrollHeight + "px";
        }
        sibling = sibling.nextElementSibling;
      }
    }

    function applyInitialHeightForTransition(element) {
      let sibling = element.nextElementSibling;
      while (sibling && !sibling.classList.contains("collapse-end")) {
        if (sibling.style.height === "") {
          sibling.style.height = sibling.scrollHeight + "px";
        }
        sibling = sibling.nextElementSibling;
      }
    }

    function closeOtherCollapses(original_element) {
      collapsibleElements.forEach((close_element) => {
        if (
          close_element != original_element &&
          hasCollapseEndSibling(close_element)
        ) {
          let sibling = close_element.nextElementSibling;
          while (sibling && !sibling.classList.contains("collapse-end")) {
            sibling.style.height = "0px";
            sibling = sibling.nextElementSibling;
          }
        }
      });
    }
  }
  //------------------- PB+J
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)"
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    var sortOptionsBtn = document.querySelector("#FacetSortDrawerForm");
    if (sortOptionsBtn && sortOptionsBtn.classList.contains("open")) {
      sortOptionsBtn.classList.toggle("open");
    }

    // document.querySelector('.image-switcher-container .first-image-selector').classList.remove('picked');
    // document.querySelector('.image-switcher-container .second-image-selector').classList.remove('picked');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      // details.removeAttribute('open');
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) {
      if (elementToFocus) {
        elementToFocus.setAttribute("aria-expanded", false);
      }
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();

    if (
      elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

customElements.define("menu-drawer", MenuDrawer);
/*
 * Rebuy Smart Cart - accessibility patch (keyboard focus management)
 * --------------------------------------------------------------------
 * Fixes the cart-dialog barrier alleged in the Abdulhadi complaint (Para 43b):
 *   - On open, moves keyboard focus INTO the cart dialog (to the Close button)
 *     instead of leaving it on the add-to-cart trigger.        [WCAG 2.4.3]
 *   - Adds a focus trap so Tab/Shift+Tab cycle within the dialog. [WCAG 2.1.2]
 *   - Escape closes the cart.                                     [WCAG 2.1.1]
 *   - Ensures the visible dialog is exposed to screen readers
 *     (aria-hidden="false", aria-label).                         [WCAG 4.1.2]
 *   - Restores focus to the opening control when the cart closes. [WCAG 2.4.3]
 *
 * IMPORTANT: The cart that opens on add-to-cart is the REBUY SMART CART app,
 * not the theme's native mini-cart (which is inactive). This patch targets
 * Rebuy's drawer (.rebuy-cart) and Rebuy's events (rebuy:smartcart.show/hide).
 *
 * INSTALL - choose ONE:
 *   A) PREFERRED - Rebuy dashboard -> Smart Cart -> Settings -> Custom Code ->
 *      Custom JavaScript. Paste everything BELOW (without needing a <script> tag).
 *   B) Theme - append the contents to assets/custom.js (already loads site-wide),
 *      or add as snippets/rebuy-cart-a11y.liquid wrapped in <script> ... </script>
 *      and {% render 'rebuy-cart-a11y' %} near the end of layout/theme.liquid.
 *
 * Verified working live on industryofallnations.com on 2026-06-23:
 * after install, opening the cart moves focus to the "Close Cart" button.
 *
 * NOTE: This is a defensive patch over a third-party app. First check whether
 * Rebuy Smart Cart has a built-in accessibility/focus setting to enable; this
 * patch is safe alongside it. Re-test after any Rebuy app update.
 */
(function () {
  if (window.__rebuyCartA11y) return;
  window.__rebuyCartA11y = true;

  var SELECTOR = '.rebuy-cart';
  var OPEN_CLASS = 'is-visible';
  var lastTrigger = null;

  function drawer() { return document.querySelector(SELECTOR); }
  function isOpen(d) { return d && d.classList.contains(OPEN_CLASS); }

  function focusables(container) {
    return [].slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
      ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
  }

  function onKeydown(e) {
    var d = drawer();
    if (!isOpen(d)) return;
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      try { window.Rebuy.SmartCart.hide(); } catch (_) {}
      return;
    }
    if (e.key !== 'Tab' && e.keyCode !== 9) return;
    var f = focusables(d);
    if (!f.length) { e.preventDefault(); d.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Remember the control that opened the cart, so focus can return to it on close.
  document.addEventListener('click', function (e) {
    var t = e.target.closest(
      '[name="add"], .btn--add-to-cart, .product__cta, .cart_view,' +
      ' [data-rebuy-open-cart], .rebuy-cart-toggle'
    );
    if (t) lastTrigger = t;
  }, true);

  document.addEventListener('keydown', onKeydown, true);

  document.addEventListener('rebuy:smartcart.show', function () {
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    if (!d.getAttribute('aria-label')) d.setAttribute('aria-label', 'Shopping cart');
    if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');
    var close = d.querySelector('.rebuy-cart__flyout-close') || focusables(d)[0] || d;
    // Defer so Rebuy finishes rendering the drawer before we move focus.
    setTimeout(function () { try { close.focus(); } catch (_) {} }, 80);
  });

  document.addEventListener('rebuy:smartcart.hide', function () {
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus(); } catch (_) {}
    }
  });
})();